import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css'],
})
export class ManualComponent implements OnInit {
  manual: string =
    'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238';
  idioma = 'es';
  constructor() {}

  ngOnInit(): void {
    if (localStorage.getItem('lenguaje')) {
      this.idioma = localStorage.getItem('lenguaje');
    }
    switch (this.idioma) {
      case 'es':
        this.manual =
          'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238';
        break;

      default:
        this.manual =
          'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238';
        break;
    }
  }
}